import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'
import { id } from 'date-fns/locale'
import { ArrowDownRight, ArrowUpRight, DollarSign, Download } from 'lucide-react'
import { useState } from 'react'

import { PageLayout } from '@/components/layout'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

import { toIdr } from '@/libs/utils/format'

export const Route = createFileRoute('/_app/report/cash-flow')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: 'Laporan Arus Kas',
    }
  },
})

function RouteComponent() {
  return (
    <PageLayout>
      <PageLayout.Header title='Laporan Arus Kas' />
      <CashFlowReportPage />
      {/* <Card className='max-w-3xl overflow-hidden p-0'>
        <CardContent className='p-0'>
          <div>
            <div className={`flex justify-between bg-muted p-2 text-muted-foreground`}>
              <h3 className='pl-3 text-sm font-medium uppercase'>Aktivitas</h3>
              <h3 className='pr-3 text-right text-sm font-medium uppercase'>Jumlah</h3>
            </div>
            <div className='flex justify-between bg-muted p-2'>
              <h3 className='font-semibold'>Aktivitas Operasional</h3>
            </div>
            <div className='flex flex-col'>
              {Object.entries({
                'Penerimaan dari pelanggan': 0,
                'Total Penerimaan dari pelanggan': 0,
                'Pembayaran ke pemasok': 0,
                'Total Pembayaran ke pemasok': 0,
                'Aset lancar lainnya': 0,
                'Total Aset lancar lainnya': 0,
                'Hutang Jangka Pendek': 0,
                'Total Hutang Jangka Pendek': 0,
                'Penerimaan/(Pengeluaran) Operasional': 0,
                'Total Penerimaan/(Pengeluaran) Operasional': 0,
              }).map(([key, value]) => {
                return (
                  <div className='flex justify-between p-2 text-sm'>
                    <h3 className='pl-3'>{key}</h3>
                    <h3>{toIdr(value)}</h3>
                  </div>
                )
              })}
            </div>
            <div className='flex justify-between bg-muted p-2'>
              <h3 className='pl-3 font-semibold'>Arus Kas Dari Aktivitas Operasional</h3>
              <h3 className='font-semibold'>{toIdr(0)}</h3>
            </div>
            <div className='mt-8 flex justify-between bg-muted p-2'>
              <h3 className='font-semibold'>Aktivitas Pendanaan</h3>
            </div>
            <div className='flex flex-col'>
              {Object.entries({
                'Penerimaan/(Pembayaran) pinjaman': 0,
                'Total Penerimaan/(Pembayaran) pinjaman': 0,
                'Ekuitas/Modal': 0,
                'Total Ekuitas/Modal': 0,
              }).map(([key, value]) => {
                return (
                  <div className='flex justify-between p-2 text-sm'>
                    <h3 className='pl-3'>{key}</h3>
                    <h3>{toIdr(value)}</h3>
                  </div>
                )
              })}
            </div>
            <div className='flex justify-between bg-muted p-2'>
              <h3 className='pl-3 font-semibold'>Arus Kas Dari Aktivitas Pendanaan</h3>
              <h3 className='font-semibold'>{toIdr(0)}</h3>
            </div>
            <div className='mt-8 flex justify-between bg-muted p-2'>
              <h3 className='pl-3 font-semibold'>Saldo Kas Awal Periode</h3>
              <h3 className='font-semibold'>{toIdr(0)}</h3>
            </div>
            <div className='flex justify-between bg-muted p-2'>
              <h3 className='pl-3 font-semibold'>Kenaikan (Penurunan) Kas</h3>
              <h3 className='font-semibold'>{toIdr(0)}</h3>
            </div>
            <div className='flex justify-between bg-muted p-2'>
              <h3 className='pl-3 font-semibold'>Saldo Kas Akhir Periode</h3>
              <h3 className='font-semibold'>{toIdr(0)}</h3>
            </div>
          </div>
        </CardContent>
      </Card> */}
    </PageLayout>
  )
}

interface CashFlowItem {
  code: string
  name: string
  amount: number
  level: number
  isHeader: boolean
  isInflow?: boolean
}

interface CashFlowData {
  operating: CashFlowItem[]
  investing: CashFlowItem[]
  financing: CashFlowItem[]
  netCashFlow: number
  beginningBalance: number
  endingBalance: number
  period: string
}

const OUTLETS = [
  { id: 'ikki_coffee', name: 'Ikki Coffee' },
  { id: 'ikki_resto', name: 'Ikki Resto' },
]

const mockCashFlowData: Record<string, CashFlowData> = {
  ikki_coffee: {
    period: '2025-11',
    beginningBalance: 15230000,
    operating: [
      {
        code: 'O100',
        name: 'Arus Kas dari Aktivitas Operasi',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      {
        code: 'O101',
        name: 'Penerimaan dari Pelanggan',
        amount: 45250000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
      { code: 'O102', name: 'Pembayaran ke Pemasok', amount: -27700000, level: 2, isHeader: false },
      { code: 'O103', name: 'Pembayaran Gaji', amount: -8500000, level: 2, isHeader: false },
      {
        code: 'O104',
        name: 'Pembayaran Operasional Lain',
        amount: -3000000,
        level: 2,
        isHeader: false,
      },
    ],
    investing: [
      {
        code: 'I100',
        name: 'Arus Kas dari Aktivitas Investasi',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      { code: 'I101', name: 'Pembelian Peralatan', amount: -5000000, level: 2, isHeader: false },
      {
        code: 'I102',
        name: 'Hasil Penjualan Aset',
        amount: 800000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
    ],
    financing: [
      {
        code: 'F100',
        name: 'Arus Kas dari Aktivitas Pendanaan',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      {
        code: 'F101',
        name: 'Setoran Modal',
        amount: 10000000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
      { code: 'F102', name: 'Pengambilan Pribadi', amount: -3000000, level: 2, isHeader: false },
    ],
    netCashFlow: 0,
    endingBalance: 0,
  },
  ikki_resto: {
    period: '2025-11',
    beginningBalance: 18900000,
    operating: [
      {
        code: 'O100',
        name: 'Arus Kas dari Aktivitas Operasi',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      {
        code: 'O101',
        name: 'Penerimaan dari Pelanggan',
        amount: 68200000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
      { code: 'O102', name: 'Pembayaran ke Pemasok', amount: -42700000, level: 2, isHeader: false },
      { code: 'O103', name: 'Pembayaran Gaji', amount: -12500000, level: 2, isHeader: false },
      {
        code: 'O104',
        name: 'Pembayaran Operasional Lain',
        amount: -4000000,
        level: 2,
        isHeader: false,
      },
    ],
    investing: [
      {
        code: 'I100',
        name: 'Arus Kas dari Aktivitas Investasi',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      { code: 'I101', name: 'Pembelian Peralatan', amount: -8000000, level: 2, isHeader: false },
      {
        code: 'I102',
        name: 'Hasil Penjualan Aset',
        amount: 1200000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
    ],
    financing: [
      {
        code: 'F100',
        name: 'Arus Kas dari Aktivitas Pendanaan',
        amount: 0,
        level: 1,
        isHeader: true,
      },
      {
        code: 'F101',
        name: 'Setoran Modal',
        amount: 15000000,
        level: 2,
        isHeader: false,
        isInflow: true,
      },
      { code: 'F102', name: 'Pengambilan Pribadi', amount: -5000000, level: 2, isHeader: false },
    ],
    netCashFlow: 0,
    endingBalance: 0,
  },
}

// Hitung net cash flow & saldo akhir
Object.keys(mockCashFlowData).forEach(outlet => {
  const d = mockCashFlowData[outlet]
  const op = d.operating.reduce((sum, i) => sum + i.amount, 0)
  const inv = d.investing.reduce((sum, i) => sum + i.amount, 0)
  const fin = d.financing.reduce((sum, i) => sum + i.amount, 0)
  d.netCashFlow = op + inv + fin
  d.endingBalance = d.beginningBalance + d.netCashFlow
})

function CashFlowReportPage() {
  const [outletId, setOutletId] = useState('ikki_coffee')
  const data = mockCashFlowData[outletId]

  const renderSection = (title: string, items: CashFlowItem[], total: number) => (
    <Card className='mb-6'>
      <CardHeader>
        <CardTitle className='text-lg font-semibold'>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className='w-full'>Uraian</TableHead>
              <TableHead className='text-right'>Jumlah</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map(item => (
              <TableRow
                key={item.code}
                className={
                  item.isHeader
                    ? `
                      bg-gray-50 font-bold
                      dark:bg-gray-800
                    `
                    : item.isInflow
                      ? 'text-green-600'
                      : 'text-red-600'
                }
              >
                <TableCell style={{ paddingLeft: `${item.level * 24}px` }}>
                  {item.isHeader ? item.name : `${item.code} - ${item.name}`}
                </TableCell>
                <TableCell className='text-right font-medium'>
                  {item.isInflow ? (
                    <span className='flex items-center justify-end gap-1'>
                      <ArrowUpRight className='h-4 w-4' />
                      {toIdr(item.amount)}
                    </span>
                  ) : item.amount < 0 ? (
                    <span className='flex items-center justify-end gap-1'>
                      <ArrowDownRight className='h-4 w-4' />({toIdr(Math.abs(item.amount))})
                    </span>
                  ) : (
                    toIdr(item.amount)
                  )}
                </TableCell>
              </TableRow>
            ))}
            <TableRow className='border-t-2 border-gray-300 font-bold'>
              <TableCell>Netto {title}</TableCell>
              <TableCell
                className={`
                  text-right
                  ${total >= 0 ? 'text-green-600' : 'text-red-600'}
                `}
              >
                {total >= 0 ? toIdr(total) : `(${toIdr(Math.abs(total))})`}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )

  const opTotal = data.operating.reduce((sum, i) => sum + i.amount, 0)
  const invTotal = data.investing.reduce((sum, i) => sum + i.amount, 0)
  const finTotal = data.financing.reduce((sum, i) => sum + i.amount, 0)

  return (
    <div className=''>
      {/* Header */}
      <div
        className={`
          mb-6 rounded-lg bg-white p-6 shadow-sm
          dark:bg-gray-800
        `}
      >
        <div
          className={`
            flex flex-col items-start justify-between gap-4
            md:flex-row md:items-center
          `}
        >
          <div>
            <h1
              className={`
                text-2xl font-bold text-gray-900
                dark:text-white
              `}
            >
              Laporan Arus Kas
            </h1>
            <p
              className={`
                mt-1 text-sm text-gray-500
                dark:text-gray-400
              `}
            >
              Pergerakan kas masuk dan keluar
            </p>
          </div>
          <div className='flex gap-3'>
            <Button variant='outline' size='sm'>
              <Download className='mr-2 h-4 w-4' />
              Export PDF
            </Button>
            <Button variant='outline' size='sm'>
              <Download className='mr-2 h-4 w-4' />
              Export Excel
            </Button>
          </div>
        </div>

        <div
          className={`
            mt-6 grid grid-cols-1 gap-4
            md:grid-cols-2
          `}
        >
          <div>
            <Label htmlFor='outlet'>Outlet</Label>
            <Select value={outletId} onValueChange={setOutletId}>
              <SelectTrigger id='outlet'>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {OUTLETS.map(o => (
                  <SelectItem key={o.id} value={o.id}>
                    {o.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Periode</Label>
            <div
              className={`
                flex items-center gap-2 pt-2 text-sm font-medium text-gray-700
                dark:text-gray-300
              `}
            >
              <DollarSign className='h-4 w-4' />
              {format(new Date(data.period + '-01'), 'MMMM yyyy', { locale: id })}
            </div>
          </div>
        </div>
      </div>

      {/* Saldo Awal */}
      <Card
        className={`
          mb-6 border-blue-200
          dark:border-blue-800
        `}
      >
        <CardContent className='pt-6'>
          <div className='flex items-center justify-between text-lg font-bold'>
            <span>Saldo Kas Awal</span>
            <span
              className={`
                text-blue-600
                dark:text-blue-400
              `}
            >
              {toIdr(data.beginningBalance)}
            </span>
          </div>
        </CardContent>
      </Card>

      {/* Arus Kas */}
      {renderSection('Arus Kas dari Aktivitas Operasi', data.operating, opTotal)}
      {renderSection('Arus Kas dari Aktivitas Investasi', data.investing, invTotal)}
      {renderSection('Arus Kas dari Aktivitas Pendanaan', data.financing, finTotal)}

      {/* Netto & Saldo Akhir */}
      <Card
        className={`
          mb-6 border-green-200
          dark:border-green-800
        `}
      >
        <CardContent className='pt-6'>
          <div className='flex items-center justify-between text-lg font-bold'>
            <span>Kenaikan (Penurunan) Bersih Kas</span>
            <span
              className={`
                flex items-center gap-1
                ${data.netCashFlow >= 0 ? 'text-green-600' : 'text-red-600'}
              `}
            >
              {data.netCashFlow >= 0 ? (
                <ArrowUpRight className='h-5 w-5' />
              ) : (
                <ArrowDownRight className='h-5 w-5' />
              )}
              {data.netCashFlow >= 0
                ? toIdr(data.netCashFlow)
                : `(${toIdr(Math.abs(data.netCashFlow))})`}
            </span>
          </div>
        </CardContent>
      </Card>

      <Card
        className={`
          border-purple-200
          dark:border-purple-800
        `}
      >
        <CardContent className='pt-6'>
          <div className='flex items-center justify-between text-xl font-bold'>
            <span>Saldo Kas Akhir</span>
            <span
              className={`
                text-purple-600
                dark:text-purple-400
              `}
            >
              {toIdr(data.endingBalance)}
            </span>
          </div>
          <Badge
            variant={data.endingBalance >= data.beginningBalance ? 'default' : 'destructive'}
            className='mt-2'
          >
            {data.endingBalance >= data.beginningBalance
              ? `Naik ${toIdr(data.endingBalance - data.beginningBalance)}`
              : `Turun ${toIdr(data.beginningBalance - data.endingBalance)}`}
          </Badge>
        </CardContent>
      </Card>
    </div>
  )
}
